import React from 'react';
import { useNavigate } from 'react-router-dom';

function ErrorPage() {
  const navigate = useNavigate();

  setTimeout(() => {
    navigate('/');
  }, 3000);

  return (
    <>
      <div className='container ' style={{ marginTop: '15rem' }}>
        <h1 className='text-center'>404 | Page Not Found</h1>
      </div>
    </>
  );
}

export default ErrorPage;
